jQuery(function () {
  var selector = "[data-behaviour=update-contenteditable-target]";

  // BEHAVIOUR

  jQuery(document).on("blur", selector, (e) => {
    const { target } = e;
    const { dataset, innerText } = target;
    const form = target.closest("form");

    if (dataset.targetSelector && form) {
      const targetInput = form.querySelector(dataset.targetSelector) ?? {};
      targetInput.value = innerText;
    }
  });
});
